import { Injectable, inject } from '@angular/core'
import { RestClientPaged } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { NumberSequence } from '../../../sequencing/number/number-sequence'
import { environment } from '../../../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class WorkCenterItemsNumberSequenceService extends RestClientPaged<NumberSequence, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const httpClient = inject(HttpClient)
    super(environment.apiPath + '/sequencing/numbers/work-center', httpClient)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public createNew(workCenterId: string): Observable<NumberSequence> {
    return this.http.get<NumberSequence>(this.getEntityUrl(workCenterId) + '/create')
  }
}
